import apiService from "@/lib/api";

const PERMISSIONS_BASE = "/api/v2/permissions";

// Read only, because the catalogue is read only. The four mutations that used
// to sit below `fetchPermissionsList` — create, update, updateStatus, delete —
// reached no server route: each slept 500ms and returned a made-up object, and
// the page reported success on top of it. The permission catalogue is seeded by
// migration and derived from `app/core/permissions.py`; there is nothing here
// for a client to write.
export const PermissionsService = {
    fetchPermissionsList: async ({
        page = 1,
        per_page = 10,
        pagination = true,
        search = '',
        ...param
    }) => {
        const params = {
            page,
            per_page,
            search,
            pagination,
            ...param
        };
        try {
            const response = await apiService.getSecure(`${PERMISSIONS_BASE}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error while fetching list:', error);
            throw error;
        }
    },
};
